<template>
    <mask id="mask0_840_5231" style="mask-type: luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="14">
        <path d="M0.4375 0.328125H14.0212V13.2326H0.4375V0.328125Z" fill="white" />
    </mask>
    <g mask="url(#mask0_840_5231)">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.8554 3.17311C14.0764 3.38309 14.0764 3.72353 13.8554 3.93352L8.47852 9.04153C8.2575 9.2515 7.89912 9.2515 7.6781 9.04153L5.24838 6.7333L1.4037 10.3857C1.18267 10.5957 0.824304 10.5957 0.603273 10.3857C0.382242 10.1758 0.382242 9.83532 0.603273 9.62535L4.84817 5.5927C5.0692 5.38272 5.42756 5.38272 5.64859 5.5927L8.07831 7.90094L13.055 3.17311C13.276 2.96313 13.6344 2.96313 13.8554 3.17311Z"
            fill="#727EA3"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.49414 3.55331C9.49414 3.25636 9.74753 3.01562 10.0601 3.01562H13.456C13.7686 3.01562 14.022 3.25636 14.022 3.55331V6.77943C14.022 7.0764 13.7686 7.31712 13.456 7.31712C13.1434 7.31712 12.8901 7.0764 12.8901 6.77943V4.091H10.0601C9.74753 4.091 9.49414 3.85027 9.49414 3.55331Z"
            fill="#727EA3"
        />
    </g>
</template>
